'use strict';

import {addCustomEventListener, addClass, removeClass} from '../helpers';

export const homeRefs = (() => {
  const replaceHeart = () => {
    const _title = document.querySelector('.home_references__title span');

    if (!_title) return;

    const text = _title.innerHTML;
    const splited = text.split("♡");
    let res = '';
    for (let i = 0, l = splited.length; i < l; i++) {
      const txt = splited[i];

      if (i > 0) {
        res += `<svg class="title-heart" fill="#000000" width="90" height="93">
                    <use href="#icon-heart--empty"></use>
                </svg>`;
      }
      res += txt;
    }
    if (res !== '') {
      _title.innerHTML = res;
    }
  };

  const init = () => {
    replaceHeart();
  };

  return {
    init
  }
})();
